<div class="main-ho-architecture">
    <div>
        <p class="title-section">Casing / Liners</p>
    </div>
    <div class="loading-shade" *ngIf="isLoading">
        <mat-spinner *ngIf="isLoading"></mat-spinner>
    </div>
    <table mat-table [dataSource]="casingsLiners" id="tblCasingsLiners">
        <ng-container matColumnDef="wellId">
            <mat-header-cell *matHeaderCellDef> wellId </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.wellId}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="wellboreId">
            <mat-header-cell *matHeaderCellDef> Wellbore </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.wellboreId}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="assemblyId">
            <mat-header-cell *matHeaderCellDef> Assembly Id </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.assemblyId}} </mat-cell>
        </ng-container>


        <ng-container matColumnDef="wellboreNo">
            <mat-header-cell *matHeaderCellDef [ngClass]="'mat-table-header'"> Wellbore </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.wellboreNo}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="assemblyName">
            <mat-header-cell *matHeaderCellDef [ngClass]="'mat-table-header'"> CSG / Liner </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.assemblyName}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="holeSize">
            <mat-header-cell *matHeaderCellDef [ngClass]="'mat-table-header'"> Diámetro de <br>Pozo [Pulg] </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.holeSize}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="groupValues">
            <mat-header-cell *matHeaderCellDef [ngClass]="'mat-table-header'" class="no-padding">
                <div class="header-group">Diámetro<br>Externo [Pulg]</div>
                <div class="header-group">Peso [lb/pie]</div>
                <div class="header-group">Grado</div>
                <div class="header-group">Conexión</div>
            </mat-header-cell>
            <mat-cell *matCellDef="let element; let i = index" class="no-padding">
                <div class="div-options" [ngClass]="{'first-row': i === indexMenuOpen}">
                    <div class="div-option">{{element.groupValues[0].nominalSize}}</div>
                    <div class="div-option">{{element.groupValues[0].weight | number: '1.1-1'}}</div>
                    <div class="div-option">{{element.groupValues[0].grade}}</div>
                    <div class="div-option">{{element.groupValues[0].threads}}</div>
                    <button #button class="button-arrow" [ngClass]="getCSSClassButton(element.groupValues)" mat-icon-button
                        [matMenuTriggerFor]="menu" #levelOneTrigger="matMenuTrigger"
                        (menuOpened)="menuOpened(levelOneTrigger,i)" (menuClosed)="menuClosed(i)">
                        <span class="material-icons-outlined span-arrow">
                            keyboard_arrow_down
                        </span>
                    </button>
                </div>
        
                <mat-menu [overlapTrigger]="false" class="mat-menu-ho" #menu="matMenu" xPosition="before" yPosition="below">
                    <div class="options-ho">
                        <ng-container *ngFor="let el of element.groupValues; first as isFirst">
                            <div *ngIf="!isFirst" class="div-options">
                                <div class="div-option">{{el.nominalSize}}</div>
                                <div class="div-option">{{el.weight | number: '1.1-1'}}</div>
                                <div class="div-option">{{el.grade}}</div>
                                <div class="div-option">{{el.threads}}</div>
                                <div>
                                    <p style="width: 20px !important;"></p>
                                </div>
                            </div>
                        </ng-container>
                    </div>
        
                </mat-menu>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="mdLanded">
            <mat-header-cell *matHeaderCellDef [ngClass]="'mat-table-header'"> MD Base <br>Casing [m] </mat-header-cell>
            <mat-cell *matCellDef="let element"><span class="table-numbers-right-align-d"> {{element.mdLanded | number: '1.2-2'}} </span></mat-cell>
        </ng-container>

        <ng-container matColumnDef="mdLinerTop">
            <mat-header-cell *matHeaderCellDef [ngClass]="'mat-table-header'"> MD Tope <br>Liner [m] </mat-header-cell>
            <mat-cell *matCellDef="let element"><span class="table-numbers-right-align-d"> {{element.mdLinerTop | number: '1.2-2'}} </span></mat-cell>
        </ng-container>

        <ng-container matColumnDef="mdMarkerTop">
            <mat-header-cell *matHeaderCellDef [ngClass]="'mat-table-header'"> MD Marker<br>Joint[m]<br>(Caño Corto)</mat-header-cell>
            <mat-cell *matCellDef="let element"><span class="table-numbers-right-align-d"> {{element.mdMarkerTop | number: '1.2-2'}} </span></mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let casing; let i = index" [ngClass]="'mat-column-save'">
                <span class="row-buttons">
                <button mat-mini-fab (click)="openComments(casingsLiners[i].comment, i, $event, readOnlyContent);" class="comment-ho-icon">
                  <mat-icon class="material-icons-outlined">chat_bubble_outline</mat-icon>
                  <div class="circle-comments" *ngIf="casingsLiners[i].comment"></div>
                  <span class = "comment">Comentar</span>
                </button>
                </span>
                <button mat-mini-fab (click)="saveCasingLiner(casing, i);" class="save-ho-icon" [disabled]="isDisabled[i]">
                <mat-icon class="material-icons-outlined">save</mat-icon>
              </button>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="noData">
            <mat-footer-cell *matFooterCellDef colspan="7">
                <div class="footer">
                    <div class="footer-no-data">No se encontraron datos.</div>
                    <div *ngIf="showFooterNoDataOrign" class="footer-no-data-origin">De existir datos en el sistema de origen, podrás visualizarlos acá.</div>
                </div>
            </mat-footer-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        <mat-footer-row *matFooterRowDef="['noData']" [ngClass]="{'hide-footer':hideFooterCasing}"></mat-footer-row>
    </table>
    <br>
    <div>
        <p class="title-section">Direccional</p>
    </div>
    <table mat-table [dataSource]="directionals" id="tblDirectionals">
        <ng-container matColumnDef="wellId">
            <mat-header-cell *matHeaderCellDef> wellId </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.wellId}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="wellboreId">
            <mat-header-cell *matHeaderCellDef> Wellbore Id</mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.wellboreId}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="wellboreNo">
            <mat-header-cell *matHeaderCellDef [ngClass]="'mat-table-header'"> Wellbore </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.wellboreNo}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="toolMaxDls">
            <mat-header-cell *matHeaderCellDef [ngClass]="'mat-table-header'"> Herramienta Max. DLS </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.toolMaxDls}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="mdMaxDoglegSev">
            <mat-header-cell *matHeaderCellDef [ngClass]="'mat-table-header'"> Profundidad de Max. DLS [m] </mat-header-cell>
            <mat-cell *matCellDef="let element"><span class="table-numbers-right-align-d"> {{element.mdMaxDoglegSev | number: '1.2-2'}} </span></mat-cell>
        </ng-container>

        <ng-container matColumnDef="maxDoglegSev">
            <mat-header-cell *matHeaderCellDef [ngClass]="'mat-table-header'"> Max. DLS [°/30m] </mat-header-cell>
            <mat-cell *matCellDef="let element"><span class="table-numbers-right-align-d"> {{element.maxDoglegSev | number: '1.3-3'}} </span></mat-cell>
        </ng-container>

        <ng-container matColumnDef="maxInclination">
            <mat-header-cell *matHeaderCellDef [ngClass]="'mat-table-header'"> Max. Ángulo [°] </mat-header-cell>
            <mat-cell *matCellDef="let element"><span class="table-numbers-right-align-d"> {{element.maxInclination | number: '1.2-2'}} </span></mat-cell>
        </ng-container>

        <ng-container matColumnDef="toolMaxInc">
            <mat-header-cell *matHeaderCellDef [ngClass]="'mat-table-header'"> Herramienta Max. Ángulo </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.toolMaxInc}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="noData">
            <mat-footer-cell *matFooterCellDef colspan="6">
                <div class="footer">
                    <div class="footer-no-data">No se encontraron datos.</div>
                    <div *ngIf="showFooterNoDataOrign" class="footer-no-data-origin">De existir datos en el sistema de origen, podrás visualizarlos acá.</div>
                </div>
            </mat-footer-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumnsDirectionals"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumnsDirectionals;"></mat-row>
        <mat-footer-row *matFooterRowDef="['noData']" [ngClass]="{'hide-footer':hideFooter}"></mat-footer-row>
    </table>

</div>
